import React, {useContext, useState} from 'react';
import {AuthContext} from "../../context/authContext";



const Login = () => {
    const [formData, setForm] = useState({"email":"","password":""});
    const [loading, setLoading] = useState(false);
    const auth = useContext(AuthContext)
    console.log("auth contextfrom auth", auth)
    const [toast, setToast] = useState(null)
    const openToast = (value)=>{
        setToast(value)
        setLoading(false)
        setTimeout(()=> setToast(null), 3000)
    }

    const formChanges = (field, value)=>{
        setForm(prev=>({
            ...prev,
            [field]:value
        }))
        
        console.log(formData)
    }

    const submitHandler = (data)=>{
        setLoading(true);
        try{
            data.preventDefault();
            console.log(formData.email, formData.password)
            auth.signIn(formData.email, formData.password, openToast)
            
        }catch(e){
            console.log(Object.keys(e));
            setLoading(false)
            openToast(e.message)

        }
    }

    // const signOut = (event)=>{
    //     event.preventDefault()
    //     auth.signOut()
    // }
    
    return ( <div className='flex'>
    
        <div className="mt-5 w-half mx-96 px-16">
            {
                toast &&
                      <div id="toast-top-right" className={`absolute flex items-center w-full max-w-xs p-4 space-x-4 font-xl font-semibold bg-indigo-400 text-white divide-x divide-gray-200 rounded-lg shadow top-5 right-5 dark:text-gray-400 dark:divide-gray-700 space-x dark:bg-gray-800 delay-200 ease-in-out ${toast}`} role="alert">
                      <div className="text-md font-semibold">{toast}</div>
                  </div>
            }

<div className="pl-8 pr-10 py-4">
        <h2 className="font-bold text-4xl tracking-wider">Welcome to MentorBoxx Team!</h2>
        <span className="font-semibold text-stone-400 text-lg tracking-widest">Work to Learn</span>
        </div>

      <div className='flex-1	basis-1/2'> 
        
       <form method='post' action="" onSubmit={submitHandler}>
      
            
            <div className="flex flex-col shadow-xl shadow-black-500/50 px-40 rounded-lg mt-32	 py-5">
            <div className="flex-1 px-4 py-3 text-left"><label htmlFor="loginEmail" >Email Address</label></div>
            <div className="flex-1"><input type="email" className ="form-input outline-gray-400 px-4 bg-gray-200 rounded-lg focus:bg-white py-3 outline-2 w-96" placeholder="Email Address" id="loginEmail" name="loginEmail" onChange={data=>formChanges("email", data.target.value)}/></div>

            <div className="flex-1 px-4 py-3"><label htmlFor="loginPassword" >Password</label></div>
            <div className="flex-1"><input placeholder="Password" type="password" className ="form-input outline-gray-400 rounded-lg bg-gray-200  focus:bg-white px-4 py-3 outline-2 w-96" name="loginPassword" id="loginPassword" onChange={data=>formChanges("password", data.target.value)}/></div>
            
            <div className="flex-1  py-3 outline-none"><a href="/" className='outline-gray-100 px-3 py-2'>Forget Password ?</a></div>

            <div className="flex-1  py-3">
                <button type="submit" className="bg-indigo-500 bg-indigo-500 shadow-lg outline-indigo-600 shadow-indigo-500/50 text-white py-2 px-3 rounded w-96">
                    {!loading && "Login"    }
                    {loading && (<svg role="status" className="mr-2 w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 text-center py-3" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                 </svg>)}
            </button> 
                
            </div>
            {/* <div className="flex-1  px-4 py-3"><button type="button" onClick={signOut} className="bg-red-500 bg-red-500 shadow-lg shadow-red-500/50 text-white py-2 px-3 rounded ">LogOut</button> </div> */}
            </div>
        </form>
        </div>
        
        </div>

        </div> )

} ;
 
export default Login;